// material-ui
import React from 'react';
import { Box, useMediaQuery, Button } from '@mui/material';

// project import
import Profile from './Profile';
import FeedbackDialog from './FeedbackDialog';
// import Notification from './Notification';
import MobileSection from './MobileSection';

// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent = () => {
    const matchesXs = useMediaQuery((theme) => theme.breakpoints.down('md'));
    const [feedbackOpen, setFeedbackOpen] = React.useState(false);

    return (
        <>
            <Box sx={{ width: '100%', ml: 1 }} />
            {/* <Notification /> */}
            {!matchesXs && (
                <Button variant="outlined" size="small" onClick={() => setFeedbackOpen(true)} sx={{ mr: 1 }}>
                    Feedback
                </Button>
            )}
            {!matchesXs && <Profile />}
            {matchesXs && <MobileSection />}
            <FeedbackDialog open={feedbackOpen} onClose={() => setFeedbackOpen(false)} />
        </>
    );
};

export default HeaderContent;
